import { Send } from 'lucide-react';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { useSendConsentRequest } from '@/features/dashboard/bookings/hooks/useSendConsentRequest.ts';

interface SendConsentRequestButtonProps {
  bookingId: string;
  displayNames: string[];
}

const SendConsentRequestButton = ({
  bookingId,
  displayNames,
}: SendConsentRequestButtonProps) => {
  const sendConsentRequest = useSendConsentRequest(bookingId);

  return (
    <ActionButton
      tone="accent"
      size="xs"
      isLoading={sendConsentRequest.isPending}
      title={`Brakuje: ${displayNames.join(', ')}`}
      onClick={() => sendConsentRequest.mutate()}
    >
      <Send />
      Wyślij prośbę o podpis
    </ActionButton>
  );
};

export default SendConsentRequestButton;
